import axios from "axios";
import { configUrl } from "../../config";


export const getAcapStudent = async (
    applicationId
) => {
    try {

        const response = await axios.get(
            `${configUrl.PredictorServer}/acap/student/${encodeURIComponent(applicationId)}`
        );

        return response?.data;

    } catch (error) {

        console.error(
            "Error fetching ACAP student:",
            error
        );

        throw error;
    }
};


export const predictAcapAdmission = async (
    applicationId
) => {
    try {

        const response = await axios.post(
            `${configUrl.PredictorServer}/acap/predict`,
            {
                applicationId
            }
        );

        return response?.data;

    } catch (error) {

        console.error(
            "Error analyzing ACAP admission chances:",
            error
        );

        throw error;
    }
};
export const getAcapCollegeBranches = async (
    college_code, pathway
) => {
    try {

        const response = await axios.get(
            `${configUrl.PredictorServer}/acap/college/${college_code}/${pathway}/branches`
        );

        return response?.data;

    } catch (error) {

        console.error(
            "Error fetching ACAP college branches:",
            error
        );

        throw error;
    }
};